// A PRIORIDADE DA CONVERSA — desligada na tela.
//
// ══════════════════════════════════════════════════════════════════════════
// 🔴 POR QUE ESTA CHAVE EXISTE (19/09/2026, pedido do Victor)
// ══════════════════════════════════════════════════════════════════════════
//
// "Quero que desative isso de prioridade, pra não aparecer. Futuramente talvez
// ativamos de novo, mas por enquanto quero que deixe inativo."
//
// Então não é código morto para apagar: é uma decisão de produto com data de
// volta marcada. Apagar obrigaria a reescrever as pílulas, as cores e o
// comando do ⌘K quando ele mudar de ideia — e o que voltaria não seria igual.
//
// 🔴 A CHAVE É UMA SÓ, E É ESTA LINHA. Espalhar `v-if="false"` por dois
// arquivos é o jeito de descobrir meses depois que um deles ficou para trás:
// a prioridade some da ficha e continua aparecendo no ⌘K, e aí alguém define
// uma prioridade que ninguém vê.
//
// Para religar: troque para `true`. Nada mais.
//
// O QUE ESTA CHAVE NÃO FAZ, de propósito:
//   - não apaga `conversations.priority` do banco. A prioridade que já foi
//     escrita continua lá, e volta à tela inteira no dia em que religar.
//   - não mexe em filtro nem em ordenação por prioridade. Eles leem o dado
//     guardado e continuam honestos; o que sai é o poder de DEFINIR.
export const PRIORIDADE_NA_TELA = false;
